/* global address_match zip_match city_match state_match group_match locale */
// TODO(tom) the above globals come from index.php vars

var defaultGlobals = {
  // start_line: undefined,
  // j: undefined,
  source: undefined,
  gbounds: undefined,
  curRow: undefined,
  succCount: undefined,
  curTimeout: undefined,
  working: undefined,
  checkGeocode: undefined,
  doneProcessing: undefined,
  geocodeDelay: undefined,
  per: {
    /**
     * Mutable array of non-thematic colors that the user impacts via the map/edit view
     */
    colors: [
      "red",
      "blue",
      "green",
      "yellow",
      "purple",
      "paleblue",
      "orange",
      "brown",
      "darkgreen",
      "pink",
    ],
    /**
     * Mutable array of thematic colors that the user impacts via the map/edit view
     */
    thematicColors: [
      "red",
      "orange",
      "yellow",
      "green",
      "paleblue",
      "blue",
      "purple",
    ],
  },
  /**
   * Mutable array of non-thematic hex colors that is updated when `per.colors` is mutated.
   */
  hex: [
    "fd7569",
    "6996fd",
    "95ea7b",
    "fdeb5a",
    "c699fd",
    "bae1fd",
    "fb8b07",
    "c79a79",
    "00bd00",
    "faa9fc",
  ],
  /**
   * Mutable array of thematic hex colors that is updated when `per.thematicColors` is mutated.
   */
  thematicHexArray: [
    "fd7569",
    "fb8b07",
    "fdeb5A",
    "95ea7b",
    "bae1fd",
    "6996fd",
    "c599fe",
  ],
  /**
   * 	Array of available colors in the BatchGeo app. Do not mutate.
   */
  colorPallet: [
    "red",
    "blue",
    "green",
    "yellow",
    "purple",
    "paleblue",
    "orange",
    "brown",
    "darkgreen",
    "pink",
  ],
  /**
   * Array of hex values for the `colorPallet` array. Do not mutate.
   */
  hexArray: [
    "fd7569",
    "6996fd",
    "95ea7b",
    "fdeb5a",
    "c699fd",
    "bae1fd",
    "fb8b07",
    "c79a79",
    "00bd00",
    "faa9fc",
  ],
  /**
   * Array of colors used by the distance calculation tools
   */
  heatColors: ["darkgreen", "green", "yellow", "orange", "red"],
  /**
   * Hex values for the heatColors array.
   */
  heatHexArray: ["00bd00", "95ea7b", "fdeb5a", "fb8b07", "db7569"],
  shapeOptions: ["pushpin", "circle", "square"],
  styleOptions: [
    "simple",
    "midnight",
    "grayscale",
    "subtle",
    "paledawn",
    "bluewater",
  ],
  validatedSource: 0,
  base:
    window.location.protocol +
    (/dev|test/gi.test(location.hostname)
      ? "//" + location.host
      : "//batchgeo.com"),
  /**
   * gC Example
   * @example
   * {
   * 	countryNameX: {
   * 	  addressX: { lt: Number, ln: Number, accuracy: String<google.maps.accuracy>, l: undefined},
   * 	  addressY: { lt: Number, ln: Number, accuracy: String<google.maps.accuracy>, l: undefined},
   * 	  ... rest,
   * 	},
   * 	...rest,
   * }
   */
  gC: {},
  handlerSet: false,
  generatorPersist: new BatchGeoPersistence({ key: "Generator" }),
  dist_name: "bg_distance",
  accuracy_name: "bg_accuracy",
  postal_name: "bg_postal",
  canned: {
    "Duke Rd  AND  Walden Ave Buffalo NY 14225us": [
      {
        address_components: [
          { long_name: "Duke Road", short_name: "Duke Rd", types: ["route"] },
          {
            long_name: "Cheektowaga",
            short_name: "Cheektowaga",
            types: ["locality", "political"],
          },
          {
            long_name: "Cheektowaga",
            short_name: "Cheektowaga",
            types: ["administrative_area_level_3", "political"],
          },
          {
            long_name: "Erie County",
            short_name: "Erie County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "14225", short_name: "14225", types: ["postal_code"] },
        ],
        formatted_address:
          "Duke Rd & Walden Galleria, Cheektowaga, NY 14225, USA",
        geometry: {
          location: {
            lat: function () {
              return 42.90880019999999;
            },
            lng: function () {
              return -78.76199309999998;
            },
          },
          location_type: "GEOMETRIC_CENTER",
          viewport: {
            south: 42.90745121970849,
            west: -78.76334208029152,
            north: 42.91014918029149,
            east: -78.7606441197085,
          },
        },
        partial_match: true,
        place_id:
          "EjVEdWtlIFJkICYgV2FsZGVuIEdhbGxlcmlhLCBDaGVla3Rvd2FnYSwgTlkgMTQyMjUsIFVTQSJmImQKFAoSCXWogFOWDNOJET69jg9s-rPeEhQKEgl1qIBTlgzTiRE-vY4PbPqz3hoUChIJ13Py75kM04kRsd6e-WKRYckaFAoSCf9lJUyWDNOJEaHYgDRfak0AIgoNAl2TGRWl3w3R",
        types: ["intersection"],
      },
    ],
    "630 Old Country Rd Garden City NY 11530us": [
      {
        address_components: [
          { long_name: "630", short_name: "630", types: ["street_number"] },
          {
            long_name: "Old Country Road",
            short_name: "Old Country Rd",
            types: ["route"],
          },
          {
            long_name: "Garden City",
            short_name: "Garden City",
            types: ["locality", "political"],
          },
          {
            long_name: "Hempstead",
            short_name: "Hempstead",
            types: ["administrative_area_level_3", "political"],
          },
          {
            long_name: "Nassau County",
            short_name: "Nassau County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "11530", short_name: "11530", types: ["postal_code"] },
        ],
        formatted_address: "630 Old Country Rd, Garden City, NY 11530, USA",
        geometry: {
          bounds: {
            south: 40.7357263,
            west: -73.6147666,
            north: 40.7403881,
            east: -73.6110258,
          },
          location: {
            lat: function () {
              return 40.7383708;
            },
            lng: function () {
              return -73.61314620000002;
            },
          },
          location_type: "ROOFTOP",
          viewport: {
            south: 40.7357263,
            west: -73.6147666,
            north: 40.7403881,
            east: -73.6110258,
          },
        },
        place_id: "ChIJr5pxJHx9wokRk6afuCscB3I",
        types: ["premise"],
      },
    ],
    "160 Walt Whitman Rd Huntington Station NY 11746us": [
      {
        address_components: [
          { long_name: "160", short_name: "160", types: ["street_number"] },
          {
            long_name: "Walt Whitman Road",
            short_name: "Walt Whitman Rd",
            types: ["route"],
          },
          {
            long_name: "Huntington Station",
            short_name: "Huntington Station",
            types: ["locality", "political"],
          },
          {
            long_name: "Huntington",
            short_name: "Huntington",
            types: ["administrative_area_level_3", "political"],
          },
          {
            long_name: "Suffolk County",
            short_name: "Suffolk County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "11746", short_name: "11746", types: ["postal_code"] },
        ],
        formatted_address:
          "160 Walt Whitman Rd, Huntington Station, NY 11746, USA",
        geometry: {
          location: {
            lat: function () {
              return 40.8229235;
            },
            lng: function () {
              return -73.41068940000002;
            },
          },
          location_type: "ROOFTOP",
          viewport: {
            south: 40.8215745197085,
            west: -73.4120383802915,
            north: 40.8242724802915,
            east: -73.40934041970849,
          },
        },
        place_id: "ChIJM_WENQQp6IkRb79odIjJUSE",
        types: ["street_address"],
      },
    ],
    "9553 Carousel Center Drive Syracuse NY 13290us": [
      {
        address_components: [
          { long_name: "9553", short_name: "9553", types: ["street_number"] },
          {
            long_name: "Carousel Center",
            short_name: "Carousel Center",
            types: ["route"],
          },
          {
            long_name: "Lakefront",
            short_name: "Lakefront",
            types: ["neighborhood", "political"],
          },
          {
            long_name: "Syracuse",
            short_name: "Syracuse",
            types: ["locality", "political"],
          },
          {
            long_name: "Onondaga County",
            short_name: "Onondaga County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "13290", short_name: "13290", types: ["postal_code"] },
        ],
        formatted_address: "9553 Carousel Center, Syracuse, NY 13290, USA",
        geometry: {
          location: {
            lat: function () {
              return 43.0670316;
            },
            lng: function () {
              return -76.17069329999998;
            },
          },
          location_type: "RANGE_INTERPOLATED",
          viewport: {
            south: 43.0656826197085,
            west: -76.17204228029152,
            north: 43.0683805802915,
            east: -76.1693443197085,
          },
        },
        place_id:
          "Ei05NTUzIENhcm91c2VsIENlbnRlciwgU3lyYWN1c2UsIE5ZIDEzMjkwLCBVU0EiGxIZChQKEgmpSc5ELPLZiRHUDDp1SrICIhDRSg",
        types: ["street_address"],
      },
    ],
    "2655 Richmond Ave Staten Island NY 10314us": [
      {
        address_components: [
          { long_name: "2655", short_name: "2655", types: ["street_number"] },
          {
            long_name: "Richmond Avenue",
            short_name: "Richmond Ave",
            types: ["route"],
          },
          {
            long_name: "Heartland Village",
            short_name: "Heartland Village",
            types: ["neighborhood", "political"],
          },
          {
            long_name: "Staten Island",
            short_name: "Staten Island",
            types: ["political", "sublocality", "sublocality_level_1"],
          },
          {
            long_name: "Richmond County",
            short_name: "Richmond County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "10314", short_name: "10314", types: ["postal_code"] },
        ],
        formatted_address: "2655 Richmond Ave, Staten Island, NY 10314, USA",
        geometry: {
          location: {
            lat: function () {
              return 40.5817346;
            },
            lng: function () {
              return -74.16595029999996;
            },
          },
          location_type: "ROOFTOP",
          viewport: {
            south: 40.5803856197085,
            west: -74.1672992802915,
            north: 40.5830835802915,
            east: -74.16460131970848,
          },
        },
        place_id: "ChIJN1BTs4FLwokR6LtN7-onL7s",
        types: ["street_address"],
      },
    ],
    "7979 Victor Road Victor NY 14564us": [
      {
        address_components: [
          { long_name: "7979", short_name: "7979", types: ["street_number"] },
          {
            long_name: "Pittsford Victor Road",
            short_name: "Pittsford Victor Rd",
            types: ["route"],
          },
          {
            long_name: "Victor",
            short_name: "Victor",
            types: ["locality", "political"],
          },
          {
            long_name: "Victor",
            short_name: "Victor",
            types: ["administrative_area_level_3", "political"],
          },
          {
            long_name: "Ontario County",
            short_name: "Ontario County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "14564", short_name: "14564", types: ["postal_code"] },
        ],
        formatted_address: "7979 Pittsford Victor Rd, Victor, NY 14564, USA",
        geometry: {
          location: {
            lat: function () {
              return 43.0299456;
            },
            lng: function () {
              return -77.44371269999999;
            },
          },
          location_type: "ROOFTOP",
          viewport: {
            south: 43.0285966197085,
            west: -77.44506168029147,
            north: 43.0312945802915,
            east: -77.44236371970851,
          },
        },
        partial_match: true,
        place_id: "ChIJm49YVt0z0YkRfqg-1AQ3wt8",
        types: ["street_address"],
      },
    ],
    "1591 Palisades Center Drive West Nyack NY 10994us": [
      {
        address_components: [
          { long_name: "1591", short_name: "1591", types: ["street_number"] },
          {
            long_name: "Palisades Center Drive",
            short_name: "Palisades Center Dr",
            types: ["route"],
          },
          {
            long_name: "West Nyack",
            short_name: "West Nyack",
            types: ["locality", "political"],
          },
          {
            long_name: "Clarkstown",
            short_name: "Clarkstown",
            types: ["administrative_area_level_3", "political"],
          },
          {
            long_name: "Rockland County",
            short_name: "Rockland County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "10994", short_name: "10994", types: ["postal_code"] },
        ],
        formatted_address:
          "1591 Palisades Center Dr, West Nyack, NY 10994, USA",
        geometry: {
          location: {
            lat: function () {
              return 41.0995868;
            },
            lng: function () {
              return -73.95915149999996;
            },
          },
          location_type: "RANGE_INTERPOLATED",
          viewport: {
            south: 41.0982378197085,
            west: -73.9605004802915,
            north: 41.1009357802915,
            east: -73.95780251970848,
          },
        },
        place_id:
          "EjMxNTkxIFBhbGlzYWRlcyBDZW50ZXIgRHIsIFdlc3QgTnlhY2ssIE5ZIDEwOTk0LCBVU0EiGxIZChQKEgnrF_Jk5-nCiREEr6UvctWitxC3DA",
        types: ["street_address"],
      },
    ],
    "125 Westchester Ave White Plains NY 10601us": [
      {
        address_components: [
          { long_name: "125", short_name: "125", types: ["street_number"] },
          {
            long_name: "Westchester Avenue",
            short_name: "Westchester Ave",
            types: ["route"],
          },
          {
            long_name: "White Plains",
            short_name: "White Plains",
            types: ["locality", "political"],
          },
          {
            long_name: "Westchester County",
            short_name: "Westchester County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "10601", short_name: "10601", types: ["postal_code"] },
        ],
        formatted_address: "125 Westchester Ave, White Plains, NY 10601, USA",
        geometry: {
          location: {
            lat: function () {
              return 41.0321204;
            },
            lng: function () {
              return -73.76017860000002;
            },
          },
          location_type: "ROOFTOP",
          viewport: {
            south: 41.03077141970849,
            west: -73.7615275802915,
            north: 41.03346938029149,
            east: -73.75882961970854,
          },
        },
        place_id: "ChIJ7eeQ3TGUwokRnsGMv5DAlaQ",
        types: ["street_address"],
      },
    ],
    "103 Prince Street New York NY 10012us": [
      {
        address_components: [
          { long_name: "103", short_name: "103", types: ["street_number"] },
          {
            long_name: "Prince Street",
            short_name: "Prince St",
            types: ["route"],
          },
          {
            long_name: "Manhattan",
            short_name: "Manhattan",
            types: ["political", "sublocality", "sublocality_level_1"],
          },
          {
            long_name: "New York",
            short_name: "New York",
            types: ["locality", "political"],
          },
          {
            long_name: "New York County",
            short_name: "New York County",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "New York",
            short_name: "NY",
            types: ["administrative_area_level_1", "political"],
          },
          {
            long_name: "United States",
            short_name: "US",
            types: ["country", "political"],
          },
          { long_name: "10012", short_name: "10012", types: ["postal_code"] },
          {
            long_name: "3218",
            short_name: "3218",
            types: ["postal_code_suffix"],
          },
        ],
        formatted_address: "103 Prince St, New York, NY 10012, USA",
        geometry: {
          bounds: {
            south: 40.72491309999999,
            west: -73.99922149999998,
            north: 40.7253164,
            east: -73.99871580000001,
          },
          location: {
            lat: function () {
              return 40.7251231;
            },
            lng: function () {
              return -73.99893409999999;
            },
          },
          location_type: "ROOFTOP",
          viewport: {
            south: 40.7237657697085,
            west: -74.00031763029153,
            north: 40.7264637302915,
            east: -73.99761966970851,
          },
        },
        place_id: "ChIJg6ep9Y5ZwokRVIkxqdR9v3I",
        types: ["premise"],
      },
    ],
  },
};

// Loop through all the defaultGlobal keys and check if window has them assigned
// or not. We need to make sure they are not already defined which is important!
// Some of these values come in async and if you just set them you could
// overwrite the new value with the default value. This is esp troublesome with
// the `per` variable which sometimes (map page) comes in async later.
Object.keys(defaultGlobals).forEach(function (globalKeyName) {
  if (typeof window[globalKeyName] === "undefined") {
    if (BatchGeoStore.getState().App.isDev)
      console.log(
        globalKeyName,
        "was undefined so setting to ",
        defaultGlobals[globalKeyName],
      );
    window[globalKeyName] = defaultGlobals[globalKeyName];
  } else if (
    typeof defaultGlobals[globalKeyName] === "object" &&
    !Array.isArray(defaultGlobals[globalKeyName])
  ) {
    // Merges objects like `window.per` and `defaultGlobals.per` instead of overwritting.
    window[globalKeyName] = {
      ...defaultGlobals[globalKeyName],
      ...window[globalKeyName],
    };
  }
});

var j, start_line, $colorRow, labeltype_;
const componentStrings =
  window.BatchGeoStrings.getStringsForComponent("BatchGeoMapMaking");
const closeString = window.BatchGeoStrings.getStringsForComponent(
  "BatchGeoContactOwner",
);
function loadExample() {
  if (BatchGeo.getCookie("examples") === 0) return;
  if (window.source.value.length) return BatchGeoTableize(window.source);
  $.get("/example_tab.txt", function (data) {
    window.source.value = data;
    BatchGeoTableize(window.source);
  });
}

window.getMaxPoints = function () {
  if (BatchGeoStore.getState().App.isLite) {
    return 15000;
  } else {
    return BatchGeoStore.getState().App.pro ? 100000 : 250;
  }
};

function submitButtonDisabledNoticeHandler() {
  if (BatchGeoStore.getState().App.isEdit) {
    if (
      confirm(
        'Since you have updated the map data you will need to "Update Map" before you can save or "Cancel".\n\nDo you want to update the map now?',
      )
    ) {
      // TODO: Make a shared handler and not manually click
      $("#mapnow_button").click();
    }
  }

  return false;
}

var colorPicker = {
  init: function (callback) {
    var self = this;

    this.element = $('<div class="color-picker"></div>');
    var pC = function () {
      self.pickColor($(this));
    };

    for (let i = 0; i < window.hexArray.length; i++) {
      var choice = $('<div class="color-choice"></div>');

      choice.css({ backgroundColor: "#" + window.hexArray[i] });
      choice.data("value", window.colorPallet[i]);
      choice.click(pC);

      this.element.append(choice);
    }

    $(".color-choice").click(function () {
      self.pickColor($(this));
    });

    this.element.append('<div class="color-picker-arrow"></div>');

    this.wrapper = $('<div class="color-picker-wrapper"></div>');
    this.wrapper.append(this.element);
    this.wrapper.hover(
      function () {
        self.show();
      },
      function () {
        self.hide();
      },
    );

    $("body").append(this.wrapper);

    this.wrapperH = this.wrapper.outerHeight();
    this.wrapperW = this.wrapper.outerWidth();

    this.callback = callback;
  },

  show: function (target) {
    if (target) {
      var pos = this.positionForTarget(target);
      this.wrapper.css({ top: pos.top + 10, left: pos.left });
      this.currentTarget = target;
    }

    this.wrapper.show();
  },

  hide: function () {
    this.wrapper.hide();
  },

  positionForTarget: function (target) {
    var pos = target.position();

    var t = pos.top - this.wrapperH;
    var l = pos.left - this.wrapperW * 0.5 + target.outerWidth() * 0.5;

    return { top: t, left: l };
  },

  pickColor: function (choice) {
    if (!this.currentTarget) return;

    var color = choice.css("background-color");
    var value = choice.data("value");

    this.currentTarget.css({ backgroundColor: color });
    this.hide();

    this.callback(this.currentTarget, value);
  },
};

function getCookie(name) {
  return (
    document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""
  );
}

function handleMapNowRequest() {
  // check geocoding usage limit before beginning geocoding
  let email = getCookie("LAST_EMAIL");
  BatchGeoApi().checkGeoCountLimit(email, function (res) {
    if (res.status == 422) {
      var response = res.responseJSON;
      var pricingUrl = response.url;
      var error = response.error;
      var level = response.level;

      var strings = BatchGeoStrings.getStringsForComponent(
        "BatchGeoSubscriptionLimits",
      );
      var message = strings.get(error, { level: level });
      var confirmText = strings.get("CONFIRM_TEXT");

      BatchGeo.customDialog(message, {
        confirmText: confirmText,
        confirmFn: () => {
          window.location.href = `${pricingUrl}?geocountExceeded=true`;
        },
      });
    } else {
      $("#fields").slideDown(function () {
        $("#geocoding").show("normal", function () {
          if (window.validatedSource || window.validateSource()) {
            window.doGeocode();
          }
        });
      });
    }
  });
}

/**
 * Pops open an alert to the user that the image could not be loaded. This will
 * only fire once per run so that the user is not bombarded with alerts.
 *
 * @param {string} src
 * @param {number} row
 */
function throttledImageErrorAlert(src, row) {
  // Only show one error per run. If it's already has shown an error, skip
  if (window.imageErrorTripped) return;

  BatchGeo.customAlert(
    `Sorry, the following image for row ${row} was not found: ${src}`,
  );

  window.imageErrorTripped = true;
}

function updatePreview(r) {
  if (!document.getElementById("preview"))
    $("#locFields").after('<div id="preview"></div>');
  // assign user selected values to rM/window.per.mapRS[r]
  // and handle address
  window.prepRow(r);
  var rM = window.per.mapRS[r];

  var options = {
    address:
      window.batchGeoGoogleMapsMarker.MarkerContent.createMarkerAddress(r),
    title: rM.t,
    description:
      window.batchGeoGoogleMapsMarker.MarkerContent.createMarkerDesc(r),
    descriptionURL: rM.u,
    descriptionIMG: rM.i,
    email: rM.e,
    lat: rM.lt,
    lon: rM.ln,
    isSubpremise: r.isSubpremise,
    dirAddr: r.dirAddr,
  };

  $("#preview").html(
    '<div id="markerBoxPreview">' +
      window.batchGeoGoogleMapsMarker.MarkerContent.createMarkerText(options, {
        useImage: window.per.use_descIMG,
      }) +
      "</div>",
  );
}

function updateColorOptions(doBuild = true) {
  var $colorOptions = $(".marker-colors table tbody tr");
  if ($colorOptions.length === 0) return;

  var $colorRowTmpl = $colorOptions.filter(".hide");

  for (let i = 0; i < window.per.dataRS.length; i++) {
    window.prepRow(i);
  }

  if (doBuild) window.batchGeoGoogleMapsMarker.MarkerGroups.buildGroups();

  $colorOptions.not($colorRowTmpl).remove();

  var showP = function () {
    colorPicker.show($(this));
  };
  var hideP = function () {
    colorPicker.hide();
  };
  var groupsArray = window.batchGeoGoogleMapsMarker.getMarkerGroupsArray();

  for (let i = 0; i < groupsArray.length; i++) {
    var group = groupsArray[i];
    var color = "#" + window.hexArray[$.inArray(group.clr, window.colorPallet)];

    $colorRow = $colorRowTmpl.clone().removeClass("hide");
    $colorRow.find(".group").text(group.name);
    $colorRow
      .find(".color div")
      .css({ backgroundColor: color })
      .hover(showP, hideP);

    $colorRowTmpl.before($colorRow);
  }

  //update the corresponding hexArray value for legend filters
  const isThematicEnabled =
    window.per.isThematic &&
    !window.per.disablethematic_cb &&
    !window.per.isCurrentThematicMarkerGroupDate;
  let currentColorArray = window.per.colors;
  let currentHexArray = window.hex;
  if (isThematicEnabled) {
    currentColorArray = window.per.thematicColors;
    currentHexArray = window.thematicHexArray;
  }
  for (let x = 0; x < currentColorArray.length; x++) {
    // take color at index x in the provided colors
    let color = currentColorArray[x];

    // find index of color in ground truth colorPallet
    let colorIndex = window.colorPallet.indexOf(color);

    let colorHex = window.hexArray[colorIndex];
    if (currentHexArray && currentHexArray[x]) {
      currentHexArray[x] = colorHex;
    }
  }
}

function updateStylingOptions() {
  var $styleOpts = $("#stylingOptions");
  if ($styleOpts.length === 0) return;

  var $colorOpts = $styleOpts.find(".marker-colors");
  var showColorOpts = true; // $("#group_sel").prop('selectedIndex') > 0; pkh: need color options for single group

  $styleOpts.toggleClass("map-options-2-col", !showColorOpts);
  $styleOpts.toggleClass("map-options-3-col", showColorOpts);
  $colorOpts.toggle(showColorOpts);
}

function initImageOptions(
  $optionContainer,
  imgDir,
  imgNames,
  callback,
  defaultSelected,
) {
  if ($optionContainer.length === 0) return;

  const $optionUpload = $optionContainer.find(".option-upload");

  for (let i = 0; i < imgNames.length; i++) {
    var $option = $('<div class="option-image"></div>');

    var imgName = imgNames[i];
    var imgPath = "/images/options/" + imgDir + "/" + imgName + ".png";

    $option.css({ backgroundImage: "url(" + imgPath + ")" });
    $option.data("value", imgName);

    if ($optionUpload.length) {
      $optionUpload.before($option);
    } else {
      $optionContainer.append($option);
    }
  }

  var $options = $optionContainer.find(".option-image");

  $options.click(function () {
    var $option = $(this);
    var $others = $option.siblings();

    $others.removeClass("option-image-selected");
    $option.addClass("option-image-selected");

    callback($option.data("value"));
  });

  $options.eq(defaultSelected).click();
}

function validateMarkerChoice() {
  if (window.per.labeltype_sel == "letters" && window.per.dataRS.length > 26) {
    BatchGeo.customAlert(
      "Note: Lettered markers will only show when less than 27 records are displayed.",
    );
  }
  if (window.per.labeltype_sel == "numbers" && window.per.dataRS.length > 99) {
    BatchGeo.customAlert(
      "Note: Numbered markers will only show when less than 100 records are displayed.",
    );
  }
}

function initMarkerColorOptions() {
  colorPicker.init(function ($target, value) {
    if (
      window.per.isThematic &&
      !window.per.disablethematic_cb &&
      !window.per.isCurrentThematicMarkerGroupDate
    ) {
      window.per.thematicColors[$target.closest("tr").index()] = value;
    } else {
      const hexValue = window.hex[window.per.colors.indexOf(value)];
      const toIndex = $target.closest("tr").index();
      window.per.colors[toIndex] = value;
      window.hex[toIndex] = hexValue;
    }
  });
}

function initMarkerShapeOptions() {
  var $elem = $(".marker-shapes .option-images");
  if ($elem.children().length > 1) return;
  initImageOptions(
    $elem,
    "shapes",
    window.shapeOptions,
    function (value) {
      window.per.shape = value;
      validateMarkerChoice();
    },
    window.shapeOptions.indexOf(window.per.shape || "pushpin"),
  );
}

function initMapStyleOptions() {
  var $elem = $(".map-styles .option-images");
  if ($elem.children().length > 0) return;
  initImageOptions(
    $elem,
    "styles",
    window.styleOptions,
    function (value) {
      window.per.style = value;
    },
    window.styleOptions.indexOf(window.per.style || "simple"),
  );
}

function endGeocode(results, status, r) {
  try {
    clearTimeout(window.curTimeout);
    window.curTimeout = null;
  } catch (err) {
    console.log(`Couldn't clear timeout on endGeocode ${err}`);
  }

  var rM = window.per.mapRS[r];
  if (rM && BatchGeo.goodLatLon(rM.lt, rM.ln)) {
    // already had coords, don't need geocode
    //TODO(tom) hmm, weird re-assign?
    // rM.lt = rM.lt;
    // rM.ln = rM.ln;
    if (!rM.accuracy) rM.accuracy = google.maps.GeocoderLocationType.ROOFTOP;
  } else if (status == "success" && results && results.ip) {
    // ip address
    rM.lt = results.loc.split(",")[0];
    rM.ln = results.loc.split(",")[1];
    rM.postal = results.postal;
    rM.l = (
      BatchGeo.ifstr(results.city) +
      " " +
      BatchGeo.ifstr(results.region) +
      " " +
      BatchGeo.ifstr(results.postal) +
      " " +
      BatchGeo.ifstr(results.country)
    ).trim();
    rM.accuracy = google.maps.GeocoderLocationType.APPROXIMATE;
  } else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
    window.geocodeDelay += 200; // add 50 miliseconds to delay, re-run below
  } else if (status != google.maps.GeocoderStatus.OK) {
    rM.lt = 0;
    rM.ln = 0;
    rM.accuracy = "unknown";
  } else if (status == google.maps.GeocoderStatus.OK) {
    if (window.geocodeDelay > 50)
      //geocodeDelay += -1; // make 5ms faster every cycle
      rM.ln = results[0].geometry.location.lng();
    rM.lt = results[0].geometry.location.lat();

    rM.postal = "";

    for (let i = 0; i < results[0].address_components.length; i++)
      if (results[0].address_components[i].types == "postal_code")
        rM.postal = results[0].address_components[i].long_name;

    try {
      if (locale != "us" && results) rM.l = results[0].formatted_address;
    } catch (err) {
      console.log(`Error setting rM.l ${err}`);
    }

    rM.accuracy = results[0].geometry.location_type;

    if (rM.accuracy != google.maps.GeocoderLocationType.APPROXIMATE)
      window.succCount++;
  }

  window.cacheRow(rM);

  window.gbounds.extend(new google.maps.LatLng(rM.lt, rM.ln));

  let thisDelay = 0;
  if (status != google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
    window.curRow++;
    thisDelay = window.geocodeDelay;
  } else {
    thisDelay = window.geocodeDelay + 10000;
  }

  window.per.geocodeDelay = window.geocodeDelay;

  // TODO(tom) there's some weird recursion happening here
  // so startRow and endGeocode rely on eachother, for now
  // let's just ignore this rule here until we can dig deeper
  return setTimeout(function () {
    // eslint-disable-next-line no-use-before-define
    while (startRow(window.curRow)) window.curRow++;
  }, thisDelay);
}

function startRow(r) {
  if (!window.working) return false;
  if (r >= window.per.dataRS.length) {
    window.stopGeocode();
    return false;
  }
  window.per.mapRS[r] = {};
  var rM = window.per.mapRS[r];

  window.prepRow(r);
  $("#geocoder_status").html(
    "Processing: " +
      rM.addr +
      " (" +
      (r + 1) +
      "/" +
      window.per.dataRS.length +
      ")",
  );

  rM.addr = BatchGeo.toStr(rM.addr);

  if (!rM.lt && rM.addr !== "" && window.gC[window.rgn][rM.addr]) {
    // cache available
    rM.lt = window.gC[window.rgn][rM.addr].lt;
    rM.ln = window.gC[window.rgn][rM.addr].ln;
    rM.accuracy = window.gC[window.rgn][rM.addr].accuracy;
    rM.l = rM.l || window.gC[window.rgn][rM.addr].l;
  }

  if (
    !BatchGeo.goodLatLon(rM.lt, rM.ln) &&
    rM.addr.split(".").length == 4 &&
    parseInt(rM.addr.split(".")[0]) >= 1 &&
    rM.addr.length <= 15
  ) {
    // ip address
    window.curTimeout = setTimeout(function (r) {
      endGeocode(null, null, r);
    }, 5000);
    $.ajax({
      //			url: window.location.protocol + "//freegeoip.net/json/" + rM.addr + "",
      url:
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/api/ipinfo/?i=" +
        rM.addr +
        "",
      dataType: "json",
      success: function (results, status) {
        endGeocode(results, status, r);
      },
    });
    window.geocodeDelay = 25;
    return false;
  } else if (!BatchGeo.goodLatLon(rM.lt, rM.ln) && rM.addr.trim() !== "") {
    if (
      Object.prototype.hasOwnProperty.call(window.canned, rM.addr + window.rgn)
    ) {
      endGeocode(window.canned[rM.addr + window.rgn], "OK", r);
      return false;
    }
    var geocoder = new google.maps.Geocoder();
    window.curTimeout = setTimeout(function (r) {
      endGeocode(null, null, r);
    }, 5000);
    if (window.gbounds.isEmpty()) {
      geocoder.geocode(
        { address: rM.addr, region: window.rgn },
        function (results, status) {
          endGeocode(results, status, r);
        },
      );
    } else {
      geocoder.geocode(
        { address: rM.addr, region: window.rgn, bounds: window.gbounds },
        function (results, status) {
          endGeocode(results, status, r);
        },
      );
    }
    return false;
  } else {
    return true;
  }
}

function dragFileCancelEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function dragFileReset(e, err) {
  if (e) dragFileCancelEvent(e);

  var droparea = $("#sourceWrap");
  var wrapper = droparea.find("div.tableize");
  var message = droparea.find("em.tableize");

  droparea.next(".drag-drop-error").remove();

  if (err) {
    BatchGeo.timer(err);

    var errorMsg =
      "&#9888; Sorry, there was a problem loading your file. Try copy & pasting your location data instead.";
    var errorDiv = $('<p class="drag-drop-error">').html(errorMsg);

    droparea.after(errorDiv);
  }

  wrapper.removeClass("tableize-drag");
  wrapper.removeClass("tableize-drop");
  message.text($("#sourceData").attr("title"));
}

function dragFileStart(e) {
  dragFileCancelEvent(e);

  var wrapper = $("#sourceWrap div.tableize");
  var message = $("#sourceWrap em.tableize");

  wrapper.addClass("tableize-drag");
  message.text("drop your file here");
}

function loadDragFileLib(type, callback) {
  var lib = type == "application/vnd.ms-excel" ? "XLS" : "XLSX";

  if (typeof window[lib] == "undefined") {
    $.getScript("/js/lib/xlsx.full.min.js")
      .done(function () {
        callback(lib);
      })
      .fail(function () {
        dragFileReset(null, "Unable to load " + lib + " library.");
      });
  } else {
    callback(lib);
  }
}

function readDragFile(file, callback, method) {
  var fileReader = new FileReader();
  fileReader.onload = function (e) {
    callback(e.target.result);
  };
  fileReader.onerror = function () {
    dragFileReset(null, "Unable to read file data.");
  };
  fileReader[method](file);
}

function readDragFileTxt(file, callback) {
  readDragFile(file, callback, "readAsText");
}

function readDragFileUrl(file, callback) {
  readDragFile(file, callback, "readAsDataURL");
}

function dragFileReady(csv) {
  if (csv.length) {
    var textarea = $("#sourceData");
    textarea.val(csv);
    //count the rows in order to check for the geocode limit
    var dataArray = BatchGeo.parseCsv(textarea.get(0).value, {
      delimiter: "\t",
    });
    const numberOfRows =
      dataArray.filter((row) => row[0].length > 0).length - 1;
    window.checkGeocodesRemaining(numberOfRows);
    BatchGeoTableize(textarea.get(0));
    window.unValidateSource();

    // An unpleasant work around for an unpleasant bug.
    // Things get stuck in a :hover state after a drop.
    $("div.tableize").addClass("tableize-unhover");
    $(window).focus(function () {
      $("div.tableize").mouseover(function () {
        $(this).removeClass("tableize-unhover");
        $(this).off("mouseover");
        $(window).off("focus");
      });
    });
  }

  dragFileReset();
}

function dragFileReadyCSV(csv) {
  var arr = BatchGeo.parseCsv(csv);
  if (arr.length > 1 && arr[0].length > 1) {
    // If we have comma-separated values we
    // need to tab-separate them instead.
    csv = BatchGeo.unparseCsv(arr, { delimiter: "\t" });
  }
  dragFileReady(csv);
}

function dragFileReadyXLS(res) {
  if (typeof res.lib == "undefined" || typeof res.url == "undefined") return;

  try {
    var SheetJS = window[res.lib];
    var urlData = res.url.split(";base64,")[1];

    var workbook = SheetJS.read(urlData, { type: "base64" });
    var sheet = workbook.Sheets[workbook.SheetNames[0]];
    var csv = SheetJS.utils.sheet_to_csv(sheet, { FS: "\t" });

    dragFileReady(csv);
  } catch (e) {
    dragFileReset(
      null,
      "Unable to convert file data into CSV format: " + e.message,
    );
  }
}

function dragFileLoading(e) {
  dragFileCancelEvent(e);

  var wrapper = $("#sourceWrap div.tableize");
  var message = $("#sourceWrap em.tableize");

  wrapper.addClass("tableize-drop");
  message.html("&hellip;loading&hellip;");

  try {
    BatchGeoStore.dispatch({ type: "GENERATOR_DATA_CHANGED" });
    var data = e.originalEvent.dataTransfer;
    var file = data.files[0];
    var type = file.type;

    if (!type) {
      if (/\.xls$/i.test(file.name)) {
        type = "application/vnd.ms-excel";
      }
      if (/\.(csv|tsv|tab)$/i.test(file.name)) {
        type = "text/csv";
      }
    } else if (type == "text/tab-separated-values") {
      type = "text/csv";
    }

    if (type == "text/csv") {
      readDragFileTxt(file, function (txt) {
        dragFileReadyCSV(txt);
      });
    } else {
      var parallelResults = {};
      loadDragFileLib(type, function (lib) {
        parallelResults.lib = lib;
        dragFileReadyXLS(parallelResults);
      });
      readDragFileUrl(file, function (url) {
        parallelResults.url = url;
        dragFileReadyXLS(parallelResults);
      });
    }
  } catch (x) {
    BatchGeoStore.dispatch({ type: "GENERATOR_DATA_RESET" });
    dragFileReset(null, "Unable to load file data: " + x.message);
  }
}
function initSourceDragDrop() {
  if (
    typeof FileReader == "undefined" ||
    typeof FileReader.prototype == "undefined" ||
    typeof FileReader.prototype.readAsDataURL == "undefined"
  )
    return;

  var droparea = $("#sourceWrap");
  var textarea = $("#sourceData");

  if (droparea.length) {
    if (locale && locale == "us") {
      droparea.parent().find(".edit-method").text("paste or drag it");
      droparea.find("em.tableize").text(textarea.attr("title"));
    }

    droparea.on("dragover", dragFileStart);
    droparea.on("dragleave", dragFileReset);
    droparea.on("drop", dragFileLoading);
  }
}

/**
 * Resets per object/values.
 * Must mutate per object directly.
 * Batchgeo modules options/state is informed by per and passed by reference.
 * Reassigning per object will break the reference and can leave module state stale/out of sync.
 */
window.resetPer = function () {
  // Map results
  window.per.mapRS = null;
  // Data results
  window.per.dataRS = null;
  // Column indexes
  window.per.coord_col = undefined;
  window.per.lat_col = undefined;
  window.per.long_col = undefined;
  window.per.postal_col = undefined;
  window.per.accuracy_col = undefined;
  window.per.address_col = undefined;
  window.per.city_col = undefined;
  window.per.state_col = undefined;
  window.per.country_col = undefined;
  window.per.zip_col = undefined;
  window.per.desc_col = undefined;
  window.per.group_col = undefined;
  window.per.title_col = undefined;
  window.per.descURL_col = undefined;
  window.per.descIMG_col = undefined;
  window.per.email_col = undefined;
  window.per.columnNames = undefined;
  window.batchGeoGoogleMapsMarker?.clearMarkersObjArray();
};

window.checkGeocodesRemaining = function (numberOfRows) {
  // could be logged in or free user
  let email = null;
  const loggedInEmail = getCookie("EMAIL");
  const lastLoggedInEmail = getCookie("LAST_EMAIL");

  if (loggedInEmail) {
    //user is logged in
    email = getCookie("EMAIL");
  } else if (lastLoggedInEmail) {
    //captures 'free' users after first map make
    //slightly wonky though becuase once you log out, this email remains
    email = getCookie("LAST_EMAIL");
  } else {
    //no email to check (assumes new free user)
    email = "";
  }
  // empty set
  if (numberOfRows < 0) {
    return;
  }

  BatchGeoApi().checkGeoCountRemaining(email, numberOfRows, function (res) {
    if (res.status == 422) {
      var response = res.responseJSON;
      var pricingUrl = response.url;
      var email = response?.email ?? "";
      var error = response.error;
      var level = response.level;

      var strings = BatchGeoStrings.getStringsForComponent(
        "BatchGeoSubscriptionLimits",
      );
      var message = strings.get(error, { level: level, email: email });
      var confirmText = strings.get("CONFIRM_TEXT");

      BatchGeo.customDialog(message, {
        confirmText: confirmText,
        confirmFn: () => {
          window.location.href = `${pricingUrl}?geocountExceeded=true`;
        },
        showDismissBtn: true,
        dismissText: "OK",
      });
    } else {
      console.log("Geocoding is available");
    }
  });
};

window.unValidateSource = function () {
  // We only want to set this once since this can be called a bunch.
  // TODO: dont use a global to track this!
  if (!window.handlerSet) {
    $("[type=submit]").on("click", submitButtonDisabledNoticeHandler);
  }

  window.handlerSet = true;
  $("#validate_status, #fields, #geocoding").hide();

  window.resetPer();
  window.validatedSource = 0;
  if (BatchGeoStore.getState().App.isEdit) {
    window.shouldRunPS = true;
  }
};

/**
 * Creates options for a select element with the id 'clustering_icon_sel'
 * by iterating through the columns of 'window.per.dataRS' and checking
 * if the values in each column are numerical. If a column is numerical,
 * its name is added as an option to the select element.
 */
window.createClusterSelectOptions = function () {
  var clusteringIconSel = document.getElementById("clustering_icon_sel") || {
    options: [],
  };

  clusteringIconSel.options.length = 0;
  clusteringIconSel.options[0] = new Option("", -1);
  window.per.clusterIconSelOptions = [];

  if (!window.per.columnNames) return; // return early if we don't have map data to process

  for (let i = 0; i < window.per.columnNames.length; i++) {
    var numberCol = true;
    var hasValues = false;
    for (let mD in window.per.dataRS) {
      var row = window.per.dataRS[mD];
      var val = row[i];
      if (val !== undefined && val.toString().length > 0) {
        hasValues = true;
        if (
          numberCol &&
          !BatchGeo.isNumber(val) &&
          !(val.substring(0, 1) === "$")
        ) {
          numberCol = false;
        }
        if (!numberCol) {
          break;
        }
      }
    }
    if (numberCol && hasValues && clusteringIconSel) {
      clusteringIconSel.options[clusteringIconSel.options.length] = new Option(
        window.per.columnNames[i].trim(),
      );

      if (window.per.clustering_icon_col == i)
        clusteringIconSel.selectedIndex = clusteringIconSel.options.length - 1;
    }
    if (numberCol && hasValues) {
      window.per.clusterIconSelOptions = [
        ...window.per.clusterIconSelOptions,
        {
          name: window.per.columnNames[i],
          clusteringIconColIndex: i,
        },
      ];
    }
  }
};

window.initClusterSelectOptionEvents = function () {
  $("#clustering_icon_mode_sel").on("change", function () {
    window.clustering_icon_mode_ = ["sum", "average"];
    window.per.clustering_icon_mode_sel =
      window.clustering_icon_mode_[this.selectedIndex];
  });
  $("#clustering_icon_sel").on("change", function () {
    window.per.clustering_icon_col = window.per.columnNames.indexOf(
      this.options[this.selectedIndex].value,
    );
  });
};

window.validateSource = function () {
  $("[type=submit]").off("click", submitButtonDisabledNoticeHandler);
  window.handlerSet = false;
  var maxPoints = window.getMaxPoints();
  var maxPointsFormatted = maxPoints.toLocaleString();
  var val = window.source.value.replace(/\s+$/, ""); // trim whitespace from end of string
  val = val.replace(/‐/g, "-"); // replace weird dashes

  var dataArray = BatchGeo.parseCsv(val, { delimiter: "\t" });

  // If there is only 1 row we create a header for the user since they most
  // likely didn't just submit a table header
  if (dataArray.length === 1) {
    // Take our one row and merge all the cells together so that we generate a
    // single cell with the address. So if you had these cells:
    // ["1234 nw 1st", "portland", "or", "97217"]
    // It would become:
    // ["1234 nw 1st portland or 97217"]
    dataArray = [["Location"], [dataArray[0].join(" ")]];
  }

  if (dataArray.length <= 0) {
    BatchGeo.customAlert(
      "Check your source data, make sure its populated correctly. Look at the example if you are having trouble.",
    );
    return 0;
  }

  var origArray = JSON.parse(JSON.stringify(dataArray));

  if (BatchGeoStore.getState().App.isEdit) $("#save").hide(); // hide save button until map is updated

  // var lastColumns = window.per.columnNames; // useful for matching up previously selected columns
  for (let i = 0; i < dataArray.length; i++) {
    var line = dataArray[i];
    if (line[0].substr(0, 1) != "#") {
      window.per.columnNames = [];
      for (j = 0; j < line.length; j++) {
        window.per.columnNames.push($.trim(line[j]));
      }
      start_line = i + 1;
      break;
    }
  }

  for (let i = 0; i < window.per.columnNames.length; i++) {
    window.per.columnNames[i] = BatchGeo.stripQuotes(window.per.columnNames[i]);
  }

  /* cleanup accuracy any distance columns */
  var trimCol = []; // track trailing columns to trim like existing accuracy and distance info

  var tC = function (name) {
    var aCol = window.per.columnNames.indexOf(name);
    if (aCol >= 0) {
      trimCol.push(aCol);
      window.per.columnNames.splice(aCol, 1);
    }
  };

  tC(window.accuracy_name);
  tC(window.dist_name);

  for (let c = 0; c < trimCol.length; c++) {
    for (let i = 0; i < dataArray.length; i++) {
      dataArray[i].splice(trimCol[c], 1);
    }
  }
  /* end cleanup accuracy and distance columns */

  // lastColumns = lastColumns || window.per.columnNames;

  dataArray.splice(0, start_line); // remove columns row and any comments
  window.per.dataRS = BatchGeoEuroDateConverter(dataArray);

  var chosenSel = [];
  var oC = function (a) {
    var o = {};
    for (let e = 0; e < a.length; e++) o[a[e]] = "";
    return o;
  };

  var pS = function (selectObj, exactMatch, partialMatch, selectIndex) {
    const selectArray = window.per.columnNames;
    let sel = -1;
    const adjustedSelectIndex = selectIndex >= 0 ? selectIndex : -1;

    exactMatch = oC(exactMatch);

    for (let i = selectObj.options.length; i > 1; i--) {
      selectObj.options.length--;
    }

    for (let c in exactMatch) {
      exactMatch[c.toLowerCase()] = "";
    }

    for (let i = 0; i < selectArray.length; i++) {
      selectObj.options[1 + i] = new Option(
        selectArray[i].trim(),
        selectArray[i].trim(),
      );
      if (i == adjustedSelectIndex) {
        sel = adjustedSelectIndex;
      } else if (
        sel < 0 &&
        selectObj.options[1 + i].value.toLowerCase().trim() in exactMatch &&
        !(i in oC(chosenSel))
      ) {
        sel = i;
      }
    }

    // if we're dealing with the img selector, append a 'None' option.
    // attempted hardcoding in option.php but we override options in the
    // code above. We also remove the 'street view' option if account
    // type is "Lite"
    if (selectObj.id === "descIMG_sel") {
      selectObj.append(new Option("NONE", "NONE"));
    }

    function complexMatch() {
      for (let c = 0; c < partialMatch.length; c++) {
        for (let i = 0; i < selectArray.length; i++) {
          if (
            !(i in oC(chosenSel)) &&
            selectObj.options[1 + i].value
              .toLowerCase()
              .trim()
              .indexOf(partialMatch[c].toLowerCase()) != -1
          ) {
            return i;
          }
        }
      }
      return -1;
    }
    if (sel < 0) {
      sel = complexMatch();
    }

    if (sel != -1) {
      chosenSel[chosenSel.length] = sel;
      selectObj.options[1 + parseInt(sel)].selected = true;
    }

    // handle "none" value on descIMG_sel and default condition
    if (adjustedSelectIndex > -1 && sel === -1) {
      selectObj.selectedIndex = adjustedSelectIndex + 1;
      return adjustedSelectIndex;
    }
    return sel;
  };

  /**
   * The createOptionsForSelectField function creates <option> elements inside
   * the chosen <select> element. It also will add the `selected` property to
   * the option tag matching the index you provide.
   *
   * @param {object} optionSettings A hash of settings to build the option
   * elements for the select field.
   * @param {number} optionSettings.defaultSelectedIndex The selected option
   * index. For example -1 will always be first in the select box. 1 will be
   * the 2nd, and so forth.
   * @param {*} optionSettings.selectElementSelector Any value that jQuery
   * accepts for a selector. For example '#foo', $('div'),
   * document.querySelector etc.
   * @param {string} defaultHtml The default HTML to be injected before adding
   * in any dynamic <option>s. This allows you to set defaults directly in the
   * HTML / PHP and they will carry over when this runs.
   */
  var createOptionsForSelectField = function (optionSettings, defaultHtml) {
    var columnNames = window.per.columnNames.filter(
      (item) => item.toLowerCase() !== "distance",
    );

    var $select = $(optionSettings.selectElementSelector);

    $select
      .empty()
      .html(defaultHtml)
      .append(
        columnNames.map(function (columnName, mapColumnIndex) {
          var cleanColumnName = columnName.trim();

          return $("<option />", {
            text: cleanColumnName,
            value: cleanColumnName,
            selected: optionSettings.defaultSelectedIndex === mapColumnIndex,
          });
        }),
      );
  };

  var latSel = document.getElementById("lat_sel");
  var longSel = document.getElementById("long_sel");

  if (latSel && maxPoints == 250) {
    // set max at 2500 if lat/long columns exist
    window.per.lat_col = pS(
      latSel,
      ["lat", "lt", "latitude"],
      [],
      window.per.lat_col,
    );
    window.per.long_col = pS(
      longSel,
      ["ln", "lng", "lon", "long", "longitude"],
      [],
      window.per.long_col,
    );
    if (window.per.lat_col >= 0) maxPoints = 2500;
  }

  if (window.per.dataRS.length > maxPoints) {
    var tooManyPointsMessage =
      "Mapping more than " +
      maxPointsFormatted +
      " records is " +
      "not supported in our " +
      (BatchGeoStore.getState().App.isLite ? "lite" : "free") +
      " product, please use BatchGeo Pro. Do you want " +
      "to continue with the first " +
      maxPointsFormatted +
      " records?";

    if (BatchGeoStore.getState().App.pro) {
      tooManyPointsMessage =
        "Mapping more than " +
        maxPointsFormatted +
        " records is " +
        "not supported. Do you want to continue with the first " +
        maxPointsFormatted +
        " records?";
    }

    if (!confirm(tooManyPointsMessage)) {
      window.per.columnNames = "";
      return 0;
    }
    window.per.dataRS.length = maxPoints;
  }

  var custeringCbEl = document.getElementById("clustering_cb");
  var $clusterOptionsEl = $("#clusteroptions");

  if (
    window.per.clustering_cb_status === undefined &&
    window.per.dataRS.length > 1000 &&
    custeringCbEl
  ) {
    custeringCbEl.checked = true;
    window.per.clustering_cb_status = true;
    BatchGeoStore.dispatch({ type: "CLUSTER_ENABLE" });
    document.getElementById("clustering_icon_cb").checked = false;
    window.per.clustering_icon_cb_status = false;
    $clusterOptionsEl.slideDown();
  }

  if (custeringCbEl.checked) {
    $clusterOptionsEl.slideDown();
  }

  if (latSel) {
    window.per.lat_col = pS(
      latSel,
      ["lat", "lt", "latitude"],
      [],
      window.per.lat_col,
    );
    window.per.long_col = pS(
      longSel,
      ["ln", "lng", "lon", "long", "longitude"],
      [],
      window.per.long_col,
    );

    window.per.postal_col = pS(
      document.getElementById("postal_sel"),
      [],
      [window.postal_name],
      window.per.postal_col,
    );
    window.per.accuracy_col = pS(
      document.getElementById("accuracy_sel"),
      [],
      [window.accuracy_name],
      window.per.accuracy_col,
    );
  }

  // If we're NOT editing then use our fancy smart logic to decide what the
  // selection options should be and what the defaults should be based on the
  // column name.
  if (!BatchGeoStore.getState().App.isEdit || window.shouldRunPS) {
    if (window.shouldRunPS) {
      window.shouldRunPS = false;
    }

    const coordOptions = ["location", "coordinates"];
    const columnNames = window.per.columnNames.map((columnName) =>
      columnName.toLowerCase(),
    );

    for (let i = 0; i < coordOptions.length; i++) {
      const index = columnNames.indexOf(coordOptions[i]);
      window.per.coord_col = index;
      if (index !== -1) {
        break;
      }
    }

    window.per.address_col = pS(
      document.getElementById("address_sel"),
      ["ip", "adress"],
      address_match.concat([
        "address",
        "house",
        "street",
        "location",
        "adresse",
        "addr",
        "כתובת",
        "INDIRIZZO",
        "住所",
        "주소",
        "Адрес",
        "Straße",
        "ENDEREÇO",
        "Dirección",
        "Straat",
        "所在地",
        "strasse",
        "locf",
        "Direccion",
        "순번",
        "LOGRADOURO",
        "Calle",
        "Endereco",
        "Adresa",
        "주 소",
        "Adresszeile",
        "site",
        "Stra",
        "Vej",
      ]),
      window.per.address_col,
    );
    window.per.city_col = pS(
      document.getElementById("city_sel"),
      [],
      city_match.concat([
        "city",
        "town",
        "address",
        "addr",
        "county",
        "street",
        "suburb",
        "citta",
        "Город",
        "cidade",
        "愛知県",
        "市区郡",
        "Stadt",
        "ciudad",
        "Ort",
        "Ville",
        "adresse",
        "Plaats",
        "所在地",
        "Città",
        "municipio",
        "MUNICÍPIO",
      ]),
      window.per.city_col,
    );
    window.per.state_col = pS(
      document.getElementById("state_sel"),
      ["st"],
      state_match.concat([
        "state",
        "province",
        "address",
        "postcode",
        "city",
        "provincia",
        "都道府",
        "estado",
        "Bundesland",
        "csz",
        "Bogstav",
      ]),
      window.per.state_col,
    );
    window.per.country_col = pS(
      document.getElementById("countryfield_sel"),
      ["country"],
      ["country", "país"],
      window.per.country_col,
    );
    window.per.zip_col = pS(
      document.getElementById("zip_sel"),
      ["zip"],
      zip_match.concat([
        "zipcode",
        "postcode",
        "zip code",
        "post code",
        "postalcode",
        "region",
        "plz",
        "country",
        "county",
        "postal",
        "cap",
        "郵便番",
        "CEP",
        "Code Posta",
        "Postleitza",
        "cp",
        "zip",
      ]),
      window.per.zip_col,
    );
    window.per.desc_col = pS(
      document.getElementById("desc_sel"),
      [],
      [],
      window.per.desc_col,
    );

    // make sure it's okay to remove this here
    window.per.group_by_sel = pS(
      document.getElementById("group_sel"),
      ["group", "category", "count"],
      group_match.concat([
        "value",
        "total",
        "price",
        "cost",
        "percentage",
        "date",
        "type",
        "status",
        "rate",
        "rating",
        "?",
        "sale",
        "rank",
        "amount",
        "size",
        "sqft",
        "grupo",
        "Групп",
        "テレマ",
        "グルー",
        "業種",
        "Territory",
        "Market",
        "priority",
        "tier",
        "quantity",
        "QTY",
        "branch",
        "product",
        "alert",
        "route",
        "source",
        "zone",
        "subject",
        "plant",
        "service",
        "marqueur",
        "Contractor",
        "Priorit",
        "登録ス",
      ]),
      window.per.group_by_sel,
    );

    if (
      window.per.group_by_sel > -1 &&
      (!window.per.group_col || window.per.group_col === -1)
    ) {
      window.per.group_col = window.per.group_by_sel;
    }
  }
  // If we ARE editing then we should have no fancy logic around selecting
  // columns and should very simply select what exists in window.per instead.
  else {
    var selectOptionColumns = [
      {
        defaultSelectedIndex: window.per.address_col,
        selectElementSelector: "#address_sel",
      },
      {
        defaultSelectedIndex: window.per.city_col,
        selectElementSelector: "#city_sel",
      },
      {
        defaultSelectedIndex: window.per.state_col,
        selectElementSelector: "#state_sel",
      },
      {
        defaultSelectedIndex: window.per.country_col,
        selectElementSelector: "#countryfield_sel",
      },
      {
        defaultSelectedIndex: window.per.zip_col,
        selectElementSelector: "#zip_sel",
      },
      {
        defaultSelectedIndex: window.per.desc_col,
        selectElementSelector: "#desc_sel",
      },
      {
        defaultSelectedIndex: window.per.group_by_sel,
        selectElementSelector: "#group_sel",
      },
    ];

    selectOptionColumns.forEach(function (optionSettings) {
      var defaultHtml = $(optionSettings.selectElementSelector).html();
      createOptionsForSelectField(optionSettings, defaultHtml);
    });
  }

  window.createClusterSelectOptions();

  window.per.title_col = pS(
    document.getElementById("title_sel"),
    [],
    ["title", "name", "company", "label"],
    window.per.title_col,
  );
  window.per.descURL_col = pS(
    document.getElementById("descURL_sel"),
    ["web", "www"],
    ["url", "website"],
    window.per.descURL_col,
  );
  if (BatchGeoStore.getState().App.isLite) {
    // remove the street view option if account type "Lite"
    document.getElementById("descIMG_sel").options[0].remove();
  }
  window.per.descIMG_col = pS(
    document.getElementById("descIMG_sel"),
    ["img"],
    ["image"],
    window.per.descIMG_col,
  );
  window.per.email_col = pS(
    document.getElementById("email_sel"),
    [],
    ["email", "e-mail"],
    window.per.email_col,
  );

  // Reset the tripped flag in case there isnt an issue anymore
  window.imageErrorTripped = false;
  function shouldValidateNextImg(nextIndex) {
    const loopMax = 10;
    return (
      !window.imageErrorTripped && // no error yet
      nextIndex < window.per.dataRS.length && // next index is in bounds
      nextIndex < loopMax // next index is less than max
    );
  }
  if (window.per.descIMG_col > 0) {
    for (let i = 0; shouldValidateNextImg(i); i++) {
      var src = window.per.dataRS[i][window.per.descIMG_col];
      // If it's a valid URL we can try to load it as an image and see
      // if it 404s
      if (BatchGeo.isValidURL(src)) {
        const tempImg = $("<img>");
        tempImg.on("error", () => {
          throttledImageErrorAlert(src, i + 1);
        });
        tempImg.attr("src", src);
      } else if (src && src.trim() !== "") {
        throttledImageErrorAlert(src, i + 1);
      }
    }
  }

  window.per.desc_col = BatchGeo.rS(document.getElementById("desc_sel"));

  if (window.per.address_col < 0) {
    if (origArray.length > 0) {
      // get a ratio of letters-to-numbers on the first line
      var line1 = origArray[0];
      var nums = line1.join("").replace(/[^0-9]/g, "").length;
      var lets = line1.join("").replace(/[^a-zA-Z]/g, "").length;
      var line1_pctg = (nums / lets) * 100;

      // get an average ratio of let-to-num on lines 2 through 10
      // and an average data-length on lines 2 through 10
      var pctgs = [];
      var lengths = [];
      for (let i = 1; i < origArray.length; i++) {
        var line2 = origArray[i];
        nums = line2.join("").replace(/[^0-9]/g, "").length;
        lets = line2.join("").replace(/[^a-zA-Z]/g, "").length;
        pctgs.push((nums / lets) * 100);
        lengths.push(line2.join("").length);
        if (i > 9) break;
      }
      var sum = 0;
      for (let i = 0; i < pctgs.length; i++) {
        sum = sum += parseInt(pctgs[i], 10);
      }
      var avg = sum / pctgs.length;
      sum = 0;
      for (let i = 0; i < lengths.length; i++) {
        sum = sum += parseInt(lengths[i], 10);
      }
      var lengths_avg = sum / lengths.length;

      // does the first row have any common header names?
      var found_known = false;
      var known_headers = [
        "city",
        "state",
        "address",
        "name",
        "province",
        "country",
        "zip",
      ];
      for (let i = 0; i < line1.length; i++) {
        if (known_headers.indexOf(line1[i].toLowerCase()) > -1) {
          found_known = true;
        }
      }

      // if the let-to-num ratio of the first line is within 6% of the average of lines 2 through 10...
      if (line1_pctg > avg - 3 && line1_pctg < avg + 3 && !found_known) {
        // if the data-length of the first line is within 6% of the average of lines 2 through 10...
        if (
          line1.join("").length > lengths_avg - 3 &&
          line1.join("").length < lengths_avg + 3
        ) {
          if (
            !confirm(
              "It looks like your data lacks column names. Are you sure you want to continue? Look at the example if you are having trouble.",
            )
          ) {
            return 0;
          }
        }
      }
    }
  }

  if (
    window.per.columnNames.length == 1 &&
    window.per.address_col < 0 &&
    window.per.city_col < 0 &&
    window.per.state_col < 0 &&
    window.per.zip_col < 0 &&
    (window.per.lat_col < 0 || window.per.long_col < 0)
  ) {
    window.per.address_col = pS(
      document.getElementById("address_sel"),
      window.per.columnNames[0],
      [],
      0,
    );
  }

  document.getElementById("num_of_columns").innerHTML =
    window.per.columnNames.length;
  document.getElementById("num_of_rows").innerHTML = window.per.dataRS.length;
  document.getElementById("validate_status").style.display = "block";

  window.per.mapRS = window.per.mapRS || [];

  if (window.per.dataRS.length) {
    updatePreview(0);
    updateColorOptions();
  }

  $("#fields").slideDown();
  $("#geocoding").show("normal");

  window.BatchGeoTrack.event({
    featureName: "Geocode",
    eventName: "Complete",
    eventValue: window.per.dataRS.length,
    eventLabel: "Rows",
  });

  window.BatchGeoTrack.event({
    featureName: "Geocode",
    eventName: "Complete",
    eventValue: window.per.columnNames.length,
    eventLabel: "Columns",
  });

  initMarkerColorOptions();
  initMarkerShapeOptions();
  initMapStyleOptions();

  window.per.labeltype_sel = window.per.labeltype_sel || "plain";
  $("#labeltype_sel option:contains(" + window.per.labeltype_sel + ")").attr(
    "selected",
    true,
  );
  window.per.clustering_icon_mode_sel =
    window.per.clustering_icon_mode_sel || "average";
  $(
    "#clustering_icon_mode_sel option:contains(" +
      window.per.clustering_icon_mode_sel +
      ")",
  ).attr("selected", true);

  window.validatedSource = 1;

  $("html, body").animate(
    {
      scrollTop: $("#fields").offset().top,
    },
    1000,
  );

  return window.per.dataRS.length;
};

window.cacheRow = function (rM) {
  window.gC[window.rgn] = window.gC[window.rgn] || {};

  rM.lt = parseFloat(rM.lt);
  rM.ln = parseFloat(rM.ln);
  if (BatchGeo.goodLatLon(rM.lt, rM.ln)) {
    // on edit screen, build geocode cache
    rM.addr = rM.addr || "";
    window.gC[window.rgn][rM.addr] = {
      lt: rM.lt,
      ln: rM.ln,
      accuracy: rM.accuracy,
      l: rM.l,
    };
    return true;
  }

  return false;
};

window.addAccuracyInfo = function () {
  // ok we're done Geocoding -- let's update the
  // textarea with the accuracy data

  var sT = function (obj) {
    if (!obj) return "";
    if (typeof obj === "string") return obj.replace(/\r?\n|\r/g, "").trim();
    return obj;
  };

  var newlines = "";

  var mapRS = window.per.mapRS;

  for (let c = 0; c < window.per.columnNames.length; c++) {
    if (
      [window.accuracy_name, window.dist_name].indexOf(
        window.per.columnNames[c],
      ) < 0
    ) {
      newlines += window.per.columnNames[c] + "\t";
    } else {
      for (let i = 0; i < window.per.dataRS.length; i++) {
        window.per.dataRS[i].splice(c, 1); // remove all of this data since its just accuracy which we will re-add below
      }
    }
  }

  if (window.per.dist_cb_status) {
    newlines += window.accuracy_name + "\t" + window.dist_name + "\n";
  } else {
    newlines += window.accuracy_name + "\n";
  }

  for (let r = 0; r < mapRS.length; r++) {
    for (let c = 0; c < window.per.columnNames.length; c++) {
      newlines += sT(window.per.dataRS[r][c]) + "\t";
    }

    if (window.per.dist_cb_status) {
      var distance = BatchGeo.distance(
        parseFloat(mapRS[0].lt),
        parseFloat(mapRS[0].ln),
        mapRS[r].lt,
        mapRS[r].ln,
      );

      // If it's the first distance it will be 0, but we want a min of 0.01
      distance = r !== 0 ? distance.toFixed(2) : "0.01";

      newlines += mapRS[r].accuracy + "\t" + distance + "\n";
    } else {
      newlines += mapRS[r].accuracy + "\n";
    }
  }

  document.getElementById("sourceData").value = newlines;
  $("#sourceData").trigger("blur");
};

window.isPuertoRicanZip = function (z) {
  // PR zip codes start with 006, 007, or 009
  // https://simple.wikipedia.org/wiki/List_of_ZIP_Code_prefixes
  const pattern = /^(006|007|009)/;
  return Boolean(pattern.test(z));
};

window.prepRow = function (r) {
  window.per.mapRS[r] = window.per.mapRS[r] || {};
  var rM = window.per.mapRS[r];
  var rowData = window.per.dataRS[r];
  rM.hClr = "";
  rM.accuracy =
    window.per.accuracy_col >= 0 ? rowData[window.per.accuracy_col] : "";
  rM.postal = window.per.postal_col >= 0 ? rowData[window.per.postal_col] : "";
  rM.a =
    window.per.address_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.address_col])
      : "";
  rM.c =
    window.per.city_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.city_col])
      : "";
  rM.s =
    window.per.state_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.state_col])
      : "";
  rM.z =
    window.per.zip_col >= 0 ? BatchGeo.ifstr(rowData[window.per.zip_col]) : "";
  rM.ct =
    window.per.country_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.country_col])
      : "";
  rM.t =
    window.per.title_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.title_col])
      : "";
  rM.u =
    window.per.descURL_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.descURL_col])
      : "";
  rM.i =
    window.per.descIMG_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.descIMG_col])
      : "";
  rM.g =
    window.per.group_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.group_col])
      : "";
  rM.e =
    window.per.email_col >= 0
      ? BatchGeo.ifstr(rowData[window.per.email_col])
      : "";

  if (window.per.lat_col >= 0 && window.per.long_col >= 0) {
    // if dataRS doesn't contain valid lt & lt
    // fallback to mapRS lt & ln if valid
    const dataRSLt = BatchGeo.ifstr(rowData[window.per.lat_col]);
    const dataRSLn = BatchGeo.ifstr(rowData[window.per.long_col]);
    const mapRSRowData = window.per.mapRS[r];
    rM.lt =
      !dataRSLt && mapRSRowData.lt !== undefined ? mapRSRowData.lt : dataRSLt;
    rM.ln =
      !dataRSLn && mapRSRowData.ln !== undefined ? mapRSRowData.ln : dataRSLn;
  } else if (window.per.coord_col >= 0) {
    const coords = rowData[window.per.coord_col].split(",");
    rM.lt = coords[0];
    rM.ln = coords[1];
  }

  rM.r = r;

  if (rM.lt && BatchGeo.isDmsCoordinate(rM.lt)) {
    rM.lt = BatchGeo.parseDms(rM.lt);
  }

  if (rM.ln && BatchGeo.isDmsCoordinate(rM.ln)) {
    rM.ln = BatchGeo.parseDms(rM.ln);
  }

  rM.d = "";

  const selectedRegion = $("#country_sel").val();

  if (
    !rM.a &&
    selectedRegion === "us" &&
    rM.z &&
    rM.z.length === 5 &&
    !window.isPuertoRicanZip(rM.z)
  ) {
    // address doesn't exist and we have a 5-digit US zip code outside of Puerto Rico.
    // zip codes from PR don't return valid geocode results.
    rM.addr = rM.z;
  } else {
    rM.addr = rM.a + " "; // prep geocode address
    rM.addr = rM.addr
      .replace("&", " AND ")
      .replace("NULL", "")
      .replace(/\\|&|#|\//g, "")
      .trim();
    if (window.per.disableroadtypes_cb) {
      rM.addr = rM.addr
        .replace(
          /\b(Blvd|Road|Avenue|Ave|Street|Drive|Parkway|Pkwy|Place|Way|Rd|Park|Ste|Ln|Lane|Ct|Dr|Court|Pl|St|Loop|Lp|Wy)\b/gi,
          "",
        )
        .trim();
    }
    if ((rM.a + rM.c).length > 0) {
      // address and city combined length is more than 0
      // add space after base address
      rM.addr = rM.addr + " ";
    }
    if (rM.c && rM.c.length > 0) {
      // add city
      rM.addr = rM.addr + rM.c;
    }
    if (rM.s && rM.s.length > 0) {
      // add state
      rM.addr = rM.addr.trim() + " " + rM.s;
    }
    if (rM.z && rM.z.length > 0) {
      // add zip code
      rM.addr = rM.addr.trim() + " " + rM.z;
    }
    if (rM.ct && rM.ct.length > 0) {
      // add country
      rM.addr = rM.addr.trim() + " " + rM.ct;
    }
  }

  if (!/¡|-/.test(rM.addr) && rM.addr.split(".").length != 4) {
    // jshint ignore:line
    rM.addr = rM.addr.replace(/\./g, ""); // not lat long coords or ip address
  }

  rM.z = rM.z || "";
};

window.filterStreetView = function () {
  // check per for streetivew references
  for (let i = 0; i < window.per.mapRS.length; i++) {
    var rM = window.per.mapRS[i];
    if (rM.i && rM.i.indexOf("api/streetview") >= 0) rM.i = "";
  }
  return true;
};

window.preSubmitCheck = function () {
  let inputtedEmail = document.getElementById("map_email").value.toLowerCase();
  BatchGeoApi().checkGeoCountLimit(inputtedEmail, function (res) {
    if (res.status == 422) {
      var response = res.responseJSON;
      var pricingUrl = response.url;
      var error = response.error;
      var level = response.level;

      var strings = BatchGeoStrings.getStringsForComponent(
        "BatchGeoSubscriptionLimits",
      );
      var message = strings.get(error, { level: level });
      var confirmText = strings.get("CONFIRM_TEXT");

      BatchGeo.customDialog(message, {
        showConfirmBtn: true,
        confirmFn: () => {
          window.location.href = `${pricingUrl}?geocountExceeded=true`;
        },
        showDismissBtn: true,
        confirmText: confirmText,
      });
    } else {
      window.jsonSubmit();
    }
  });
  return false;
};

window.jsonSubmit = async function () {
  var getMapEmail = function () {
    return document.getElementById("map_email").value.toLowerCase();
  };

  var maxPoints = window.getMaxPoints();

  var postMapEl = document.getElementById("post_map");

  // upload msg
  postMapEl.old_value = postMapEl.value;
  postMapEl.value = "Uploading Map, Please Wait...";
  $("#post_map").removeClass("green").addClass("red").prop("disabled", true);
  $("body button").css("cursor", "progress");

  var undoMsg = function () {
    postMapEl.value = postMapEl.old_value;
    $("#post_map").removeClass("red").addClass("green").prop("disabled", false);
    $("body button").css("cursor", "auto");
  };

  if (!window.per.mapRS || window.per.mapRS == 0) {
    // no data, stop
    BatchGeo.customDialog("It appears your map has no data, please try again.");
    undoMsg();
    return false;
  }

  if (window.per.mapRS.length > maxPoints) {
    // use regular alert because we are already in a colorbox
    BatchGeo.customDialog(
      "The map only supports showing up to " +
        maxPoints.toLocaleString() +
        " points, currently " +
        window.per.mapRS.length +
        " are in your source data. Please reduce the number of points in your source data, or upgrade to BatchGeo Pro.",
    );
    undoMsg();
    return false;
  }

  if (!BatchGeo.validateEmail(getMapEmail())) {
    // use regular alert because we are already in a colorbox
    BatchGeo.customDialog("Please enter a valid Email address.");
    undoMsg();
    return false;
  }

  if (
    document.getElementById("agree_terms") &&
    !$("#agree_terms").prop("checked")
  ) {
    // use regular alert because we are already in a colorbox
    BatchGeo.customDialog(
      "You must agree to the BatchGeo Terms of Use to continue.",
    );
    undoMsg();
    return false;
  }

  if (
    $("#share_password").prop("checked") &&
    !document.getElementById("password_text").value.trim()
  ) {
    BatchGeo.customDialog(
      "A password is required for password protected maps.",
    );
    undoMsg();
    return false;
  }

  const lastEmail = getMapEmail();
  BatchGeo.setCookie("LAST_EMAIL", lastEmail, 7);
  const emailStatus = JSON.parse(
    await $.ajax({
      url: "/api/emailCheck/?email=" + encodeURIComponent(getMapEmail()),
      type: "POST",
    }),
  );

  if (emailStatus.bounced || emailStatus.blocked) {
    document.getElementById("map_email").value = "";
    const message = BatchGeoStrings.getStringsForComponent(
      "BatchGeoEmailCheck",
    ).get("TROUBLE_SENDING_ERROR", { email: lastEmail });
    BatchGeo.customDialog(message);
    undoMsg();
    return false;
  }

  BatchGeo.emailBelongsToSubscriptionSync(getMapEmail(), function (msg) {
    if (!parseInt(msg)) document.getElementById("map_email").value = "";
  });

  if (getMapEmail() === "") {
    BatchGeo.customDialog(
      "Please ensure the input email belongs to an active BatchGeo account.",
    );
    undoMsg();
    return false;
  }

  var map = window.batchGeoGoogleMapsManager.getMap();
  var gA = window.batchGeoGoogleMapsMarker.getMarkerGroupsArray();
  var legend = window.batchGeoGoogleMapsMarker.MarkerLegend;
  window.per.map_title = document.getElementById("map_title").value;
  window.per.map_description = document.getElementById("map_description").value;
  window.per.map_type = map.getMapTypeId();
  window.per.view_sel = (function () {
    switch (map.getMapTypeId()) {
      case google.maps.MapTypeId.ROADMAP:
        return 0;
      case google.maps.MapTypeId.SATELLITE:
        return 1;
      case google.maps.MapTypeId.HYBRID:
        return 2;
      case google.maps.MapTypeId.TERRAIN:
        return 3;
    }
  })();
  window.per.locale = $("#country_sel").val() || locale;
  window.per.address_match = address_match;
  window.per.zip_match = zip_match;
  window.per.city_match = city_match;
  window.per.state_match = state_match;
  window.per.linkopwin_cb = document.getElementById("linkopwin_cb").checked;
  window.per.disable_exports = $("#disable_exports").prop("checked");
  // This option isn't available to non-pro user's so we force it to a boolean.
  // jQuery will return `undefined` if #heatmap_default doesn't exist in the DOM.
  window.per.heatmap_default = !!$("#heatmap_default").prop("checked");

  // This should be available to both pro and non-pro users.
  window.per.map_mode = $(".map-mode-toggle [name=map_mode]")
    .filter(":checked")
    .val();

  if (gA.length > 1 || legend.getFilters().length) {
    legend.filterColumns();
    window.per.legend_columns = legend.getColumns();
  }

  window.filterStreetView();

  document.getElementById("jsonData").value = JSON.stringify(window.per);
  try {
    const map_email = $("#map_email").val() || "N/A";
    gtag.push("event", "GA4 - Map Save Email", {
      map_email,
    });
  } catch (err) {
    console.log(`Failed to push google event: ${err}`);
  }

  window.generatorPersist.set({ lastEmail: getMapEmail() });

  var sourceUrl = $("#sourceData").data("source-url");
  var oauthToken = $("#sourceData").attr("data-oauth-token"); // Use .attr so JSON isn't auto-parsed.
  if (sourceUrl && oauthToken) {
    document.getElementById("source_url").value = sourceUrl;
    document.getElementById("oauth_token").value = oauthToken;
  }

  /**
   * Given a link to the new map, this will generate the logged in or logged out success message when the map is saved
   * on the server.
   * @param {string} link A link to where you want the user to be taken to on the "View map" button
   * @return {string} Returns HTML to be displayed as the success message
   */
  var getMapSuccessHtml = function (link) {
    if (BatchGeoStore.getState().App.pro) {
      return (
        "<p>" +
        componentStrings.get("SECRET_URL") +
        // must use the select range for iOS
        '<input onClick="this.setSelectionRange(0, this.value.length)" class="post-map-create-modal-input" value="' +
        link +
        '">' +
        '<br><a href="' +
        link +
        '" class="button green inline go-to-button">' +
        componentStrings.get("VIEW_SAVED_MAP") +
        "</a>" +
        '<button onclick="window.scrollTo(0,0);location.reload()" class="button white inline">' +
        componentStrings.get("CREATE_MAP") +
        "</button>" +
        "</p>"
      );
    } else {
      return (
        "<p>" +
        componentStrings.get("EMAIL_LINK") +
        "</p>" +
        '<p> <a href="' +
        componentStrings.get("PRICE_URL") +
        '">' +
        componentStrings.get("UPGRADE") +
        "</a> </p>" +
        "<p>" +
        '<button onclick="window.scrollTo(0,0);location.reload()" class="button green inline free-plan-button">' +
        closeString.get("CLOSE_BUTTON") +
        "</button>" +
        "</p>"
      );
    }
  };

  var addMapSuccess = function (alias) {
    var link = location.protocol + "//" + location.host + "/map/" + alias;
    $.colorbox({
      className: "map-success-dialog",
      fixed: true,
      escKey: false,
      overlayClose: false,
      scrolling: false,
      transition: "none",
      fadeOut: 250,
      closeButton: false,
      width: "758px",
      maxWidth: "95%",
      html:
        '<div class="post-map-create-modal">' +
        "<h1>Map Saved</h1>" +
        getMapSuccessHtml(link) +
        "</div>",
    });
  };

  var addMapError = function (message) {
    message =
      message ||
      "There was a problem uploading your map, please try again in a few moments.";
    BatchGeo.customDialog(message, {
      showConfirmBtn: false,
      showDismissBtn: true,
      dismissText: "OK",
    });

    undoMsg();
  };

  //determine planId for current user
  let planId;
  $.ajax({
    url: "/api/checkPlanId/?email=" + getMapEmail(),
    async: true,
    type: "GET",
    success: function (body) {
      planId = body;
    },
    error: function () {
      planId = 0;
    },
  });

  BatchGeo.timer("begin addMap post");

  const mapJson = JSON.parse($("#jsonData").val());

  if (mapJson.legend_columns) {
    const currentSelectedColumn = mapJson.group_col;

    mapJson.legend_columns.forEach((column) => {
      if (
        mapJson.group_data &&
        mapJson.group_data.filter((data) => data.group_col === column)
          .length === 0
      ) {
        window.batchGeoGoogleMapsMarker.MarkerLegend.selectColumn(
          column,
          false,
          true,
        );
      }
    });

    mapJson.group_data = window.per.group_data;
    window.batchGeoGoogleMapsMarker.MarkerLegend.selectColumn(
      currentSelectedColumn,
      true,
    );
  }

  const buf = window.FFlate.strToU8(JSON.stringify(mapJson));
  const compressed = window.FFlate.compressSync(buf, { level: 6, mem: 8 });
  const mapBlob = new Blob([compressed], { type: "application/json" });

  const formData = new FormData();
  formData.append("mapJson", mapBlob);
  formData.append("password", $("input[name=password]").val());
  formData.append("private_", $("input[name=private]:checked").val());
  formData.append("email", getMapEmail());
  formData.append("render_method", $("#render_method").val());
  formData.append("contact_me", $("#contact_me").val());
  formData.append("map_mode", window.per.map_mode);

  // if no email, add map will fail
  let customerEmail = getMapEmail();

  $.ajax({
    url: "/api/addMap/",
    type: "POST",
    processData: false,
    contentType: false,
    data: formData,
    cache: false,
    success: function (body) {
      const { alias, error } = JSON.parse(body);
      if (alias) {
        addMapSuccess(alias);

        BatchGeo.outlierHandler();

        //Used for GTM to determine if a map is created by a free user or paid user
        if (planId > 0) {
          gtag("event", "GA4 - AddMap - Paid", {
            page_title: "Add Map paid",
            page_location: "https://batchgeo.com/addMap",
            page_path: "/addMap",
            value: "paid",
            customerEmail: customerEmail,
            //send_to: 'UA-104467-4'
          });
        } else {
          //free map creation
          gtag("event", "GA4 - AddMap - Free", {
            page_title: "Add Map free",
            page_location: "https://batchgeo.com/addMap",
            page_path: "/addMap",
            value: "free",
            customerEmail: customerEmail,
            //send_to: 'UA-104467-4'
          });
        }
      } else if (error) {
        addMapError(error);
      } else {
        addMapError();
      }
    },
    error: function (body) {
      if (body.responseJSON) {
        addMapError(body.responseJSON.error);
      } else if (body.responseText) {
        try {
          const responseObj = JSON.parse(body.responseText);
          addMapError(responseObj.error);
        } catch (err) {
          addMapError();
        }
      } else {
        addMapError();
      }
    },
  }); // submit form, response will be in script

  BatchGeo.timer("end addMap post");

  return false;
};

/**
 * Handles updating the 'per.group_col' state, which informs the marker legend which
 * column should be selected
 */
window.resolveGroupColState = function () {
  if (!window.per.dist_cb_status) {
    window.per.group_col = window.per.group_by_sel;
  } else if (
    window.per.group_col === -1 &&
    window.getDistanceColumnIndex() > -1
  ) {
    window.per.group_col = window.getDistanceColumnIndex();
  }
};

/**
 * Gets last index of window.per.columnNames and checks if it is 'Distance'
 * If it's distance, returns index(Number).
 * If it's not distance, returns -1
 */
window.getDistanceColumnIndex = function () {
  const lastIndex = window.per.columnNames.length - 1;
  if (window.per.columnNames[lastIndex].toLowerCase() === "distance") {
    return lastIndex;
  } else {
    return -1;
  }
};

/**
 * Removes 'Distance' from per.columnNames and relevant data from 'per.dataRs' rows if it exists.
 */
window.findAndRemoveDistanceFromFirst = function () {
  const deleteIndex = window.getDistanceColumnIndex();
  if (deleteIndex > -1) {
    window.per.columnNames.splice(deleteIndex, 1);
    window.per.dataRS.forEach((row) => row.splice(deleteIndex, 1));
  }
  window.resolveGroupColState();
};

/**
 * injects 'Distance' into per.columnNames
 * This enabled the marker legend to include
 * the 'Distance' as a selectable option.
 */
window.addDistanceFromFirst = function () {
  const alreadyExists = window.getDistanceColumnIndex() > -1;
  if (!alreadyExists) {
    window.per.columnNames.push("Distance");
  }
  window.resolveGroupColState();
};

/**
 * If 'Distance' is in 'per.columnNames' but relevant data is null in 'per.dataRS'
 * this function will update the 'per.dataRS' data to be valid.
 *
 * This covers the case in which the 'Distance From First' map setting is selected
 * before geocoding results are available to populate 'Distance' group.
 *
 * Is called in 'batchGeoGoogleMapsMarker.doMap' fn
 */
window.resolveDistanceFromFirst = function () {
  console.time("Resolve Distance Values in per.dataRS");
  let distIndex = window.getDistanceColumnIndex();
  if (distIndex === -1) {
    window.addDistanceFromFirst();
    distIndex = window.per.columnNames.length - 1;
  }

  const firstRow = window.per.mapRS[0];
  const firstRowLt = parseFloat(firstRow.lt);
  const firstRowLn = parseFloat(firstRow.ln);

  window.per.mapRS.forEach((currentRow, i) => {
    let distance = "0";
    if (i > 0) {
      currentRow.lt = parseFloat(currentRow.lt);
      currentRow.ln = parseFloat(currentRow.ln);
      distance = BatchGeo.distance(
        firstRowLt,
        firstRowLn,
        currentRow.lt,
        currentRow.ln,
      ).toFixed(2);
    }

    currentRow.distance = distance;
    window.per.dataRS[i][distIndex] = distance;
  });
};

window.initAfterModules = function () {
  window.source = document.getElementById("sourceData");
  if (window.per.dist_sel === undefined) {
    window.per.dist_sel = document.getElementById("dist_sel").selectedIndex;
  }
  window.per.use_descIMG = true;
  if (BatchGeoStore.getState().App.isEdit && window.per.dist_cb_status)
    document.getElementById("dist_cb").checked = true;
  window.per.dist_cb_status = !!$("#dist_cb").prop("checked");
  window.per.field_cb_status = document.getElementById("field_cb")
    ? document.getElementById("field_cb").checked
    : true;

  if (!document.getElementById("alias")) loadExample(); // not on edit screen, run example

  if (!document.getElementById("alias"))
    document.getElementById("linkopwin_cb").checked = true;
  if (!BatchGeo.modulesInitialized) {
    //We still don't have modules ready
    return window.batchGeoMap.initializeModules(window.initAfterModules);
  }

  window.per.disableChoropleth = window.per.disableChoropleth ?? true;

  initSourceDragDrop();

  $("#validate_button").on("click", function (e) {
    e.preventDefault();
    window.validateSource();
  });

  $("#mapnow_button").on("click", function (e) {
    e.preventDefault();
    // lock geocode limit check
    window.checkGeocodesRemainingEngaged = true;
    handleMapNowRequest();
  });

  var $sourceData = $("#sourceData");
  $sourceData.on("click", function () {
    this.select();
  });

  $sourceData.on("change", function () {
    window.unValidateSource();
    // unlock geocode limit check
    window.checkGeocodesRemainingEngaged = false;
    BatchGeoStore.dispatch({ type: "GENERATOR_DATA_CHANGED" });
  });

  $("#advanced_button").on("click", function (e) {
    e.preventDefault();
    $("#advancedOptions").slideDown();
    document.getElementById("advanced_button").style.display = "none";

    $("html, body").animate(
      { scrollTop: $("#advancedOptions").offset().top },
      1000,
    );
  });

  $("#geocode_button").on("click", function (e) {
    e.preventDefault();
    // lock geocode limit check
    window.checkGeocodesRemainingEngaged = true;
    handleMapNowRequest();
  });

  $(".inline").colorbox({
    width: "650px",
    maxWidth: "95%",
    inline: true,
    scrolling: false,
    href: "#inline_save",
    onComplete: function () {
      $("#inline_save")
        .find(".map-mode-toggle")
        .html(BatchGeoUi.MapModeToggle());
      $.colorbox.resize();
    },
  });

  if (
    document.getElementById("map_email").value.length === 0 &&
    window.generatorPersist.fetch("lastEmail")
  ) {
    document.getElementById("map_email").value =
      window.generatorPersist.fetch("lastEmail");
  }

  var onChangeCallback = function (context, prop, update) {
    // clear lt/ln values in mapRs
    if (window.per.mapRS) {
      window.per.mapRS.forEach((item) => {
        item.lt = "";
        item.ln = "";
      });
    }

    // update state and preview
    window.per[prop] = BatchGeo.rS(context);
    if (BatchGeoStore.getState().App.isEdit) $("#save").hide();
    if (update) updatePreview(0);
  };

  $("#address_sel").on("change", function () {
    onChangeCallback(this, "address_col", true);
  });
  $("#city_sel").on("change", function () {
    onChangeCallback(this, "city_col", true);
  });
  $("#state_sel").on("change", function () {
    onChangeCallback(this, "state_col", true);
  });
  $("#zip_sel").on("change", function () {
    onChangeCallback(this, "zip_col", true);
  });
  $("#countryfield_sel").on("change", function () {
    onChangeCallback(this, "country_col", true);
  });
  $("#lat_sel").on("change", function () {
    onChangeCallback(this, "lat_col");
  });
  $("#long_sel").on("change", function () {
    onChangeCallback(this, "long_col");
  });
  $("#clustering_icon_mode_sel").on("change", function () {
    window.clustering_icon_mode_ = ["sum", "average"];
    window.per.clustering_icon_mode_sel =
      window.clustering_icon_mode_[this.selectedIndex];
  });
  $("#clustering_icon_sel").on("change", function () {
    window.per.clustering_icon_col = window.per.columnNames.indexOf(
      this.options[this.selectedIndex].value,
    );
    updatePreview(0);
  });
  $("#title_sel").on("change", function () {
    onChangeCallback(this, "title_col", true);
  });
  $("#desc_sel").on("change", function () {
    onChangeCallback(this, "desc_col", true);
  });
  $("#group_sel").on("change", function () {
    window.per.group_by_sel = BatchGeo.rS(this);
    if (window.per.group_by_sel === -1 && window.per.dist_cb_status) {
      window.per.group_col = window.getDistanceColumnIndex();
    } else {
      window.per.group_col = BatchGeo.rS(this);
    }
    window.batchGeoGoogleMapsMarker.MarkerLegend.selectColumn(
      window.per.group_col,
    );
    updatePreview(0);
    updateStylingOptions();
    updateColorOptions();
  });
  $("#descURL_sel").on("change", function () {
    onChangeCallback(this, "descURL_col", true);
  });
  $("#descIMG_sel").on("change", function (e) {
    e.target.value.toLowerCase() === "none"
      ? (window.per.use_descIMG = false)
      : (window.per.use_descIMG = true);
    onChangeCallback(this, "descIMG_col", true);
  });
  $("#email_sel").on("change", function () {
    onChangeCallback(this, "email_col", true);
  });
  $("#dist_sel").on("change", function () {
    window.per.dist_sel = this.selectedIndex;
  });
  $("#clustering_icon_cb").on("change", function () {
    window.per.clustering_icon_cb_status = this.checked;
  });
  $("#labeltype_sel").on("change", function () {
    labeltype_ = ["plain", "letters", "numbers"];
    window.per.labeltype_sel = labeltype_[this.selectedIndex];
    validateMarkerChoice();
  });
  $("#dist_cb").on("change", function () {
    window.per.dist_cb_status = this.checked;
  });
  $("#hideaddr_cb").on("change", function () {
    window.per.hideaddr_cb = this.checked;
  });
  $("#linkopwin_cb").on("change", function () {
    window.per.linkopwin_cb = this.checked;
  });
  $("#disablethematic_cb").on("change", function () {
    window.per.disablethematic_cb = this.checked;
    updateColorOptions();
  });
  $("#disableroadtypes_cb").on("change", function () {
    window.per.disableroadtypes_cb = this.checked;
  });
  $("#disable_exports").on("change", function () {
    window.per.disable_exports = this.checked;
  });
  $("#view_sel").on("change", function () {
    window.per.view_sel = this.selectedIndex;
  });

  // When you change the privacy settings we want to clear out the password
  // field if you had set it so it's not confusing that there's a password set
  // but the radio isn't set
  $("input[name=private]").on("change", function () {
    $("#inline_save").find("[name=password]").val("");
  });

  $("#clustering_cb").on("change", function () {
    window.per.clustering_cb_status = this.checked;
    BatchGeoStore.dispatch({
      type: "CLUSTER_SET_ENABLED",
      enabled: this.checked,
    });
    if (!this.checked) {
      window.per.clustering_icon_cb_status = this.checked;
      $("#clustering_icon_cb").attr("checked", this.checked);
    }
    $("#clusteroptions").toggle(this.checked);
  });

  $("#heatmap_default").on("change", function () {
    // If this was changed we need to unblock marker rendering so when the user
    // clicks "update" it will render the new marker type
    BatchGeoStore.dispatch({ type: "MARKER_DRAWER_ENABLE_DRAWING" });
    window.per.heatmap_default = $("#heatmap_default").prop("checked");
  });

  if (window.per.locale === undefined) {
    window.rgn = locale || "";

    $.ajax({
      async: true,
      type: "GET",
      url: "/api/maxmind/",
      success: function (results) {
        $(
          '#country_sel option[value="' +
            results.country_code.toLowerCase() +
            '"]',
        ).attr("selected", true);
      },
      dataType: "json",
      cache: true,
    });
  } else {
    // eslint-disable-next-line no-global-assign
    window.rgn = locale = window.per.locale;
    $('#country_sel option[value="' + window.rgn + '"]').attr("selected", true);
  }
};

BatchGeoStore.addListener("CustomExtents", "bounds", function (newState) {
  window.per.custom_extent = newState.bounds;
});
